import { IResource } from "../i18n";

const translation_en_us: IResource = {
    header_title: 'MEET | Colloqui online senza stress',
    header_menu_api: 'API',
    header_signup_text: 'Iscriviti gratis',
    header_signin_text: 'Registrati',
    header_dashboard_text: 'La mia scrivania',

    general_title_text: 'Colloqui online senza stress',
    general_cta_text_one: 'Risparmia soldi, tempo e stress',
    general_cta_text_two: 'per organizzare ed effettuare',
    general_cta_text_three: 'i tuoi colloqui di lavoro online',
    general_cta_button: 'PROVALO ORA GRATIS',

    general_cta_contact: 'Contattaci: office@meet.rs',
    general_cta_consent_one: 'Questo sito utilizza i cookie solo a fini di analisi e personalizzazione',
    general_cta_consent_two: 'Continuando a utilizzare questo sito, accetti le',
    general_tos_text: "Condizioni d'uso",
    general_tos_tooltip: "Condizioni d'uso Vivani Meet",
    general_cookies_text: 'Gestione dei Cookie',
    general_cookies_tooltip: 'Informativa sui cookie di Vivani Meet',
    general_privacy_text: 'Informativa sulla privacy    ',
    general_privacy_tooltip: 'Informativa sulla privacy di Vivani Meet',
    general_refund_text: 'Condizioni di reso',
    general_refund_tooltip: 'Condizioni di reso di Vivani Meet',

    usecase_title_head: 'Realizzato su misura per i colloqui online',
    usecase_title_subhead: 'Meet è stato progettato specificatamente per i colloqui online, in base alle esigenze riportate dai responsabili di selezione del personale',
    usecase_interviewer_title: 'FACILE PER CONDURRE I COLLOQUI',
    usecase_interviewer_subtitle: 'Catalogo delle attività’',
    "usecase_interviewer_body": "Definisci in anticipo le domande ed i task e goditi il colloquio",
    usecase_interviewer_learnmore: 'Per saperne di più ',
    usecase_interviewer_imgalt: 'Intervista alla lavagna',
    usecase_collaboration_title: 'LAVORARE INSIEME',
    usecase_collaboration_subtitle: 'Progettato per collaborare',
    usecase_collaboration_body_one: 'Chiama, programma, disegna, scrivi ...',
    usecase_collaboration_body_two: 'Tutti insieme, tutti contemporaneamente',
    usecase_collaboration_learnmore: 'Per saperne di più',
    usecase_collaboration_imgalt: 'Intervista alla lavagna',    
    usecase_recruiter_title: 'FACILE PER I RESPONSABILI DI SELEZIONE',
    usecase_recruiter_subtitle: 'Facciamo il tuo lavoro per te',
    usecase_recruiter_body: 'Pianificazione automatica, trascrizioni,, promemoria ai partecipanti, raccolta di feedback ...',
    usecase_recruiter_learnmore: 'Per saperne di più',
    usecase_recruiter_imgalt: 'Intervista alla lavagna',    
    usecase_call_title: 'VIDEOCHIAMATE DI GRUPPO IN FULL HD',
    usecase_call_subtitle: 'Con registrazione e trascrizione automatiche',
    usecase_call_body_one: 'Zero plug-in, applicazioni o installazioni',
    usecase_call_body_two: 'Serve soltanto il tuo browser!',
    usecase_call_learnmore: 'Per saperne di più',
    usecase_call_imgalt: 'Intervista alla lavagna',     

    footer_email_text: "Contattaci",

    signout_menu_text: "Disconnessione",
    me_menu_text: "Il mio incontro",

    help_menu_text: "Aiuto",

    cta_nosignup_text: "Nessuna iscrizione o download richiesti.",
    
    // Change language
    language_selector_title: "Language",
    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsch",
    language_it_title: "Italian",
    language_pl_title: "Polski",
    
    general_cta_button_quick: "OSPITA UNA RIUNIONE",
    general_cta_text_all: "Risparmia soldi, tempo e stress per organizzare ed effettuare i tuoi colloqui di lavoro online",
    
    header_title_short: "Vivani Meet",
}

export default translation_en_us;